var _effectorFileName = "/src/page-content/pair-lessons/components/pluses-pair-lessons/pluses-pair-lessons.tsx";
import { useTranslation } from 'next-i18next';
import { PAIR_LESSONS_PLUSES_LIST } from '@/page-content/pair-lessons/constants/pluses-list';
import { Article } from '@/shared/components/article';
import { TextPlusesList } from '@/shared/components/text-pluses-list';
export const PlusesPairLessons = () => {
  const {
    t
  } = useTranslation('pair-lessons-pluses');
  const items = PAIR_LESSONS_PLUSES_LIST.map(item => ({
    header: t(item.headerKey),
    text: t(item.textKey)
  }));
  return <Article>
      <h2 className="mb-4 header-h2 sm:mb-8">{t('title')}</h2>

      <TextPlusesList items={items} />
    </Article>;
};